module.exports = __webpack_public_path__ + "static/media/empty.e684def8.webp";